import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import HomeLayout from '../../components/layout/HomeLayout'
import LeftSidebar from './LeftSidebar'
import RightContent from './RightContent'
import { useAuth } from '../../contexts/AuthContext'
import logger from '../../lib/logger'
import type { HomeTab } from './types'

export default function Home() {
  const location = useLocation()
  const { user } = useAuth()
  const activeTab: HomeTab = location.pathname === '/projects' ? 'projects' : 'explore'

  // Print ID Token when user logs in
  useEffect(() => {
    if (user?.token) {
      logger.info('=== User ID Token (Home Page) ===')
      logger.info(user.token)
      logger.info('================================')
    }
  }, [user?.token])

  return (
    <HomeLayout
      sidebar={<LeftSidebar activeTab={activeTab} />}
      content={<RightContent activeTab={activeTab} />}
    />
  )
}
